import React, { useEffect, useRef, useState } from 'react';

import Button from '@mui/material/Button';
import PlumbingIcon from '@mui/icons-material/Plumbing';

import CreateBackflowJobGroupModal from '../components/CreateBackflowJobGroupModal';
import ListPage, { ListPageRef } from '../../../sharedModules/listPage/ListPage';
import axios from '../../../sharedModules/utils/axios.utils';

import { backflowJobGroupsColumns } from '../constants/backflowListColumns';

const BACKFLOW_STATUS_OPTIONS = [
  { value: 'approved', label: 'Approved' },
  { value: 'closed_no_log', label: 'Closed - No Log' },
  { value: 'complete', label: 'Complete' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'manual_review', label: 'Manual Review' },
  { value: 'not_needed', label: 'Log Not Needed' },
  { value: 'not_started', label: 'Not Started' },
  { value: 'overdue', label: 'Overdue' },
  { value: 'pending_approval', label: 'Pending Approval' },
];

const defaultFilterSetting = {
  status_in: ['in_progress', 'not_started', 'overdue'],
  company_name_eq: '',
  backflow_dates_scheduled_date_not_null: 1,
};

const clearedFilterSetting = { ...defaultFilterSetting, status_in: [] };

const columns = backflowJobGroupsColumns().filter(
  (col: any) => !['Completed', 'Water Authority', 'Authority-Provided Fields'].includes(col.name),
);

const BackflowJobGroupsListPage: React.FunctionComponent = () => {
  const listRef = useRef<ListPageRef | null>(null);

  const [createJobGroupModalOpen, setCreateJobGroupModalOpen] = useState<boolean>(false);

  const filterDefinitions = [
    { label: 'Status', type: 'multiSelect', param: 'status_in', choices: BACKFLOW_STATUS_OPTIONS, width: 4 },
    { label: 'Scheduled', type: 'datePicker', param: 'backflow_dates_scheduled_date', width: 5 },
  ];

  const handleJobGroupCreated = () => {
    listRef.current?.refetch();
  };

  return (
    <>
      <CreateBackflowJobGroupModal
        fetchBackflowJobGroups={handleJobGroupCreated}
        createJobGroupModalOpen={createJobGroupModalOpen}
        setCreateJobGroupModalOpen={setCreateJobGroupModalOpen}
      />
      <ListPage
        ref={listRef}
        clickableRows
        clearedFilterSetting={clearedFilterSetting}
        columns={columns}
        controller="backflows/backflow_job_groups"
        defaultFilters={defaultFilterSetting}
        defaultSort="updated_at desc"
        filterDefinitions={filterDefinitions}
        includeFilterBar
        queryPlaceholder="Order # or Customer Name"
        rowClickPath="backflow_tests/backflow_job_groups"
        title="Upcoming Tests"
        titleIcon={<PlumbingIcon />}
        button={
          <Button variant="contained" color="primary" onClick={() => setCreateJobGroupModalOpen(true)}>
            Import Work Order
          </Button>
        }
      />
    </>
  );
};

export default BackflowJobGroupsListPage;
